import {
  AttachMoney as PriceListIcon,
  CloudDownload as DownloadIcon,
  Map as ProductIcon,
  Tune as OptionIcon,
} from "@mui/icons-material";
import { SpeedDial, SpeedDialAction } from "@mui/material";
import { useDownloadFile } from "../../../components/downloadFileButton/useDownloadFile";
import { useSnackbar } from "notistack";
import { getProductsCsv, getProductsOptionsCsv } from "./productCsvApi";
import { useState } from "react";
import { PriceListCsvExportDialog } from "./PriceListCsvExportDialog";

enum OptionNames {
  PRODUCTS = "products",
  PRODUCT_OPTIONS = "productOptions",
  PRICES = "prices",
}

const options = [
  {
    name: OptionNames.PRODUCTS,
    apiDefinition: getProductsCsv,
    filename: "produkty.csv",
  },
  {
    name: OptionNames.PRODUCT_OPTIONS,
    apiDefinition: getProductsOptionsCsv,
    filename: "opcje.csv",
  },
];

const ProductCsvExport = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const { download, isLoading } = useDownloadFile({
    apiDefinition: (key) => {
      const def = options.find((o) => o.name === key)?.apiDefinition;
      return def!();
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się pobrać CSV. Powód: ${(error as Error).message}`, { variant: "error" });
    },
    filename: (key) => options.find((o) => o.name === key)!.filename,
  });

  return (
    <div>
      <SpeedDial
        color="secondary"
        title="Pobierz CSV"
        icon={<DownloadIcon />}
        ariaLabel="Pobierz CSV"
        direction="up"
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        aria-disabled={isLoading}
      >
        {open && (
          <SpeedDialAction
            key={OptionNames.PRODUCTS}
            icon={<ProductIcon />}
            slotProps={{
              tooltip: { open, title: "Produkty" },
            }}
            onClick={() => download(OptionNames.PRODUCTS)}
          />
        )}
        {open && (
          <SpeedDialAction
            key={OptionNames.PRODUCT_OPTIONS}
            icon={<OptionIcon />}
            slotProps={{
              tooltip: { open, title: "Opcje" },
            }}
            onClick={() => download(OptionNames.PRODUCT_OPTIONS)}
          />
        )}
        {open && (
          <SpeedDialAction
            key={OptionNames.PRICES}
            icon={<PriceListIcon />}
            slotProps={{
              tooltip: { open, title: "Cenniki" },
            }}
            onClick={() => setDialogOpen(true)}
          />
        )}
      </SpeedDial>
      <PriceListCsvExportDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </div>
  );
};

export default ProductCsvExport;
